module.exports = __webpack_public_path__ + "img/bghead-phone.f43b4055.png";